import { render, staticRenderFns } from "./ClienteTable.vue?vue&type=template&id=0137b9f2"
import script from "./ClienteTable.vue?vue&type=script&lang=js"
export * from "./ClienteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports